import {
  BodyLarge,
  BodyMedium,
} from "../../components/StyledComponents/Typography/Typography.tsx";
import {
  DetailGroupCS,
  TableGroupCS,
  tableColumnsMappingCS,
} from "../../constants";
import { format, parseISO, isValid } from "date-fns";
export const returnDefaultColumnConfigs = () => {
  return {
    tableGroup: TableGroupCS,
    detailGroup: DetailGroupCS,
  };
};

export const returnDefaultColumnConfigsForTable = () => {
  const renderCellFunctions = {
    UpTime: (params) => {
      let upTimeValue = "";
      let localDateStr = "";

      const msg = params?.value || "";
      const upTime = msg.split(",")[2]?.substr(8) || "";

      let months = 0,
        days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0;

      const monthMatch = upTime.match(/([\d.]+)mo/);
      const dayMatch = upTime.match(/([\d.]+)d/);
      const hourMatch = upTime.match(/([\d.]+)h/);
      const minuteMatch = upTime.match(/([\d.]+)m/);
      const secondMatch = upTime.match(/([\d.]+)s/);

      if (monthMatch) months = parseFloat(monthMatch[1]);
      if (dayMatch) days = parseFloat(dayMatch[1]);
      if (hourMatch) hours = parseFloat(hourMatch[1]);
      if (minuteMatch) minutes = parseFloat(minuteMatch[1]);
      if (secondMatch) seconds = parseFloat(secondMatch[1]);

      const MINUTES_IN_YEAR = 525600;
      const MINUTES_IN_MONTH = 43800;
      const MINUTES_IN_DAY = 1440;

      let totalMinutes =
        months * MINUTES_IN_MONTH +
        days * MINUTES_IN_DAY +
        hours * 60 +
        minutes +
        seconds / 60;

      const yearsOut = Math.floor(
        totalMinutes / MINUTES_IN_YEAR
      );
      totalMinutes %= MINUTES_IN_YEAR;

      const monthsOut = Math.floor(
        totalMinutes / MINUTES_IN_MONTH
      );
      totalMinutes %= MINUTES_IN_MONTH;

      const daysOut = Math.floor(
        totalMinutes / MINUTES_IN_DAY
      );
      totalMinutes %= MINUTES_IN_DAY;

      const hoursOut = Math.floor(totalMinutes / 60);
      totalMinutes %= 60;

      const minutesOut = Math.round(totalMinutes);

      const upTimeObj = {
        y: yearsOut,
        mo: monthsOut,
        d: daysOut,
        h: hoursOut,
        m: minutesOut,
      };
      const filteredUpTimeObj = {};
      for (const key in upTimeObj) {
        if (upTimeObj[key] > 0) {
          filteredUpTimeObj[key] = upTimeObj[key];
        }
      }
      if (Object.keys(filteredUpTimeObj).length > 0) {
        upTimeValue = Object.entries(filteredUpTimeObj)
          .map(([key, value]) => `${value}${key}`)
          .join(" ");
      }
      // Extract and format local date from "Time:"
      const timeMatch = msg.match(/Time:\s+(.+?),/);
      if (timeMatch && timeMatch[1]) {
        const utcDate = new Date(timeMatch[1] + " UTC");
        if (!isNaN(utcDate)) {
          const localDate = new Date(utcDate);

          const now = new Date();
          const isToday =
            localDate.getFullYear() === now.getFullYear() &&
            localDate.getMonth() === now.getMonth() &&
            localDate.getDate() === now.getDate();

          if (!isToday) {
            const yyyy = localDate.getFullYear();
            const mm = String(
              localDate.getMonth() + 1
            ).padStart(2, "0");
            const dd = String(localDate.getDate()).padStart(
              2,
              "0"
            );
            const hh = String(
              localDate.getHours()
            ).padStart(2, "0");
            const min = String(
              localDate.getMinutes()
            ).padStart(2, "0");
            localDateStr = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
          }
        }
      }
      return (
        <div>
          <BodyLarge>{upTimeValue}</BodyLarge>
          {localDateStr && (
            <BodyMedium>{localDateStr}</BodyMedium>
          )}
        </div>
      );
    },
    Warranty_Start: (params) => {
      if (!params.value) return <></>;
      const warrantyStartDate = isValid(
        parseISO(params?.value)
      )
        ? format(parseISO(params?.value), "MM/dd/yyyy")
        : "";
      return <BodyLarge>{warrantyStartDate}</BodyLarge>;
    },
    Warranty_End: (params) => {
      if (!params.value) return <></>;
      const warrantyEndDate = isValid(
        parseISO(params?.value)
      )
        ? format(parseISO(params?.value), "MM/dd/yyyy")
        : "";
      return <BodyLarge>{warrantyEndDate}</BodyLarge>;
    },
    Status: (params) => {
      return <BodyLarge>{params?.value}</BodyLarge>;
    },
    THs: (params) => {
      return (
        <BodyLarge>
          {params?.value ? `${params.value} TH/s` : ""}
        </BodyLarge>
      );
    },
    Power: (params) => {
      return (
        <BodyLarge>
          {params?.value ? `${params.value} W` : ""}
        </BodyLarge>
      );
    },
    JTHs: (params) => {
      return (
        <BodyLarge>
          {params?.value ? `${params.value} J/THs` : ""}
        </BodyLarge>
      );
    },
  };
  return Object.entries(tableColumnsMappingCS).map(
    ([headerName, field]) => {
      return {
        field: field,
        headerName: headerName,
        minWidth: 106,
        flex: 1,
        renderCell: renderCellFunctions[field]
          ? renderCellFunctions[field]
          : (params) => {
              return <BodyLarge>{params?.value}</BodyLarge>;
            },
      };
    }
  );
};
